module.exports = __webpack_public_path__ + "static/media/vesicula.1cf07508.png";